import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductDocument.Update.IRequest;
type Response = Api.Core.ProductDocument.Update.IResponse;
type Headers = Api.Core.ProductDocument.Update.IHeaders;
const url = '/api/ProductManagement/ProductDocument/:productId/:documentId';
export default async function productDocumentUpdateApi(
  productId: number,
  documentId: number,
  body: Request
): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { productId, documentId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
